export default __webpack_public_path__ + "static/media/survey-food.751bce06.png";